import { useEffect, useRef } from "react";

/**
 * Trustpilot "Review Collector" TrustBox.
 * Renders the official Trustpilot widget container and asks Trustpilot to
 * (re)render it after mount — required for client-side routed apps.
 */
export default function TrustpilotReviewCollector() {
  const ref = useRef(null);

  useEffect(() => {
    if (window.Trustpilot && ref.current) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  return (
    <section
      data-testid="trustpilot-section"
      aria-label="Leave us a review on Trustpilot"
      className="border-y border-border bg-secondary"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 md:py-8">
        <div
          ref={ref}
          className="trustpilot-widget"
          data-locale="en-US"
          data-template-id="56278e9abfbbba0bdcd568bc"
          data-businessunit-id="6a39674664265226696b26ca"
          data-style-height="52px"
          data-style-width="100%"
          data-token="175a9005-ea65-4052-91e3-f1e8e0bff005"
        >
          <a
            href="https://www.trustpilot.com/review/repairpoint.in"
            target="_blank"
            rel="noopener noreferrer"
          >
            Trustpilot
          </a>
        </div>
      </div>
    </section>
  );
}
